import * as React from 'react'
import { InputBaseProps, InputBase } from '../InputBase'

// eslint-disable-next-line
export interface StandardInputProps extends InputBaseProps {}

export const StandardInput = React.forwardRef<
  HTMLDivElement,
  StandardInputProps
>(function StandardInput(props, ref) {
  const {
    fullWidth = false,
    inputComponent = 'input',
    multiline = false,
    slotProps,
    slots,
    type = 'text',
    ...other
  } = props

  return (
    <InputBase
      slots={slots}
      slotProps={slotProps}
      fullWidth={fullWidth}
      inputComponent={inputComponent}
      multiline={multiline}
      ref={ref}
      type={type}
      {...other}
    />
  )
})

// @ts-ignore - We add this property to find this component when wrapped in FormControl
StandardInput.factorName = 'Input'
